import React from 'react';

function Calendar() {
  return (
<div className="centered-page">
      <h2>Crew Calendar</h2>
      <iframe
        src="https://calendar.google.com/calendar/embed?src=f1d52cde9f7164e66db625648589186e78ef37237748b9612c0bc207aadbd470%40group.calendar.google.com&ctz=America%2FDetroit&mode=AGENDA"
        style={{ border: 0 }}
        width="100%"
        height="600"
        frameBorder="0"
        scrolling="no"
        title="Crew Calendar"
      ></iframe>
    </div>
  );
}

export default Calendar;